export const TestIds = {
  CATEGORIES_SELECTOR: 'categories-selector',
  PRODUCTS_SELECTOR: 'product-selector',
  ATTRIBUTES_SELECTOR: 'attributes-selector',
  TAGS_SELECTOR: 'tags-selector',
  TAG_VALUE: 'tag-value',
  PRODUCT_PILL: 'product-pill',
  ATTRIBUTE_VALUE_PILL: 'attribute-value-pill',
  ATTRIBUTE_VALUE: 'attribute-label',
  ERROR_RETRIEVING_DATA: 'error-retrieveing-data',
  ERROR_SCOPE_TOO_BIG: 'error-too-big',
  ERROR_GENERATING_SCOPE: 'error-generating-scope',
  ERROR_DETAIL_GENERATING_SCOPE: 'error-detail-generating-scope',
  PRODUCTS_MODE_TOGGLE: 'products-mode-toggle',
  PRODUCTS_CSV_INPUT: 'products-csv-input',
  PRODUCTS_CSV_APPLY_BUTTON: 'products-csv-apply-button',
  PRODUCTS_CSV_UNKNOWN_WARNING: 'products-csv-unknown-warning',
} as const;
